// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_shipping_delivery_body = /** @type {(inputs: {}) => string} */ () => {
	return `Standard delivery takes 2-4 business days across Cyprus after dispatch. Delivery times may vary during holidays or peak periods.`
};

const el_shipping_delivery_body = /** @type {(inputs: {}) => string} */ () => {
	return `Η τυπική παράδοση διαρκεί 2-4 εργάσιμες ημέρες σε ολόκληρη την Κύπρο μετά την αποστολή. Οι χρόνοι παράδοσης μπορεί να διαφέρουν σε περιόδους αργιών.`
};

const ru_shipping_delivery_body = /** @type {(inputs: {}) => string} */ () => {
	return `Стандартная доставка по Кипру занимает 2-4 рабочих дня после отправки. Сроки могут отличаться в праздничные и пиковые периоды.`
};

const he_shipping_delivery_body = /** @type {(inputs: {}) => string} */ () => {
	return `משלוח רגיל אורך 2-4 ימי עסקים ברחבי קפריסין לאחר השליחה. זמני האספקה עשויים להשתנות בתקופות חג או עומס.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const shipping_delivery_body = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.shipping_delivery_body(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("shipping_delivery_body", locale)
	if (locale === "en") return en_shipping_delivery_body(inputs)
	if (locale === "el") return el_shipping_delivery_body(inputs)
	if (locale === "ru") return ru_shipping_delivery_body(inputs)
	if (locale === "he") return he_shipping_delivery_body(inputs)
	return "shipping_delivery_body"
};